import * as Types from '../types.generated'

import { gql } from '@apollo/client'
import { OrganizationDetailsFragmentDoc } from '../fragments/OrganizationDetails.generated'
import { OrganizationsListFragmentDoc } from '../fragments/OrganizationsList.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export const GetPaginatedOrganizationsFromFirstFragmentDoc = gql`
  fragment getPaginatedOrganizationsFromFirst on Query {
    fromFirst: organizations(first: $limit, after: $cursor, text: $text) {
      ...OrganizationsList
    }
  }
  ${OrganizationsListFragmentDoc}
`
export const GetPaginatedOrganizationsFromLastFragmentDoc = gql`
  fragment getPaginatedOrganizationsFromLast on Query {
    fromLast: organizations(last: $limit, before: $cursor, text: $text) {
      ...OrganizationsList
    }
  }
  ${OrganizationsListFragmentDoc}
`
export const GetOrganizationBySlugDocument = gql`
  query GetOrganizationBySlug($slug: String!) {
    organization(slug: $slug) {
      ...OrganizationDetails
    }
  }
  ${OrganizationDetailsFragmentDoc}
`

/**
 * __useGetOrganizationBySlugQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOrganizationBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>(GetOrganizationBySlugDocument, options)
}
export function useGetOrganizationBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>(GetOrganizationBySlugDocument, options)
}
export type GetOrganizationBySlugQueryHookResult = ReturnType<typeof useGetOrganizationBySlugQuery>
export type GetOrganizationBySlugLazyQueryHookResult = ReturnType<typeof useGetOrganizationBySlugLazyQuery>
export type GetOrganizationBySlugQueryResult = Apollo.QueryResult<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>
export const GetPaginatedOrganizationsDocument = gql`
  query getPaginatedOrganizations($limit: Int, $cursor: Cursor, $text: String, $isFromFirst: Boolean!) {
    ...getPaginatedOrganizationsFromFirst @include(if: $isFromFirst)
    ...getPaginatedOrganizationsFromLast @skip(if: $isFromFirst)
  }
  ${GetPaginatedOrganizationsFromFirstFragmentDoc}
  ${GetPaginatedOrganizationsFromLastFragmentDoc}
`

/**
 * __useGetPaginatedOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedOrganizationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      text: // value for 'text'
 *      isFromFirst: // value for 'isFromFirst'
 *   },
 * });
 */
export function useGetPaginatedOrganizationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>(GetPaginatedOrganizationsDocument, options)
}
export function useGetPaginatedOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>(GetPaginatedOrganizationsDocument, options)
}
export type GetPaginatedOrganizationsQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationsQuery>
export type GetPaginatedOrganizationsLazyQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationsLazyQuery>
export type GetPaginatedOrganizationsQueryResult = Apollo.QueryResult<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>
export type GetOrganizationBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']
}>

export type GetOrganizationBySlugQuery = {
  __typename?: 'Query'
  organization?: {
    __typename?: 'Organization'
    id: string
    name: string
    description: string
    slug: string
    socialUrls: Array<{ __typename?: 'SocialURL'; type: Types.SocialUrlType; url: string }>
    consortiums: Array<{
      __typename?: 'Consortium'
      id: string
      name: string
      description: string
      slug: string
      frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
      logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
    }>
    logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
  } | null
}

export type GetPaginatedOrganizationsFromFirstFragment = {
  __typename?: 'Query'
  fromFirst: {
    __typename?: 'OrganizationConnection'
    edges: Array<{
      __typename?: 'OrganizationEdge'
      cursor: any
      node: {
        __typename?: 'Organization'
        id: string
        name: string
        description: string
        slug: string
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}

export type GetPaginatedOrganizationsFromLastFragment = {
  __typename?: 'Query'
  fromLast: {
    __typename?: 'OrganizationConnection'
    edges: Array<{
      __typename?: 'OrganizationEdge'
      cursor: any
      node: {
        __typename?: 'Organization'
        id: string
        name: string
        description: string
        slug: string
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}

export type GetPaginatedOrganizationsQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>
  cursor?: Types.InputMaybe<Types.Scalars['Cursor']>
  text?: Types.InputMaybe<Types.Scalars['String']>
  isFromFirst: Types.Scalars['Boolean']
}>

export type GetPaginatedOrganizationsQuery = {
  __typename?: 'Query'
  fromFirst: {
    __typename?: 'OrganizationConnection'
    edges: Array<{
      __typename?: 'OrganizationEdge'
      cursor: any
      node: {
        __typename?: 'Organization'
        id: string
        name: string
        description: string
        slug: string
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
  fromLast: {
    __typename?: 'OrganizationConnection'
    edges: Array<{
      __typename?: 'OrganizationEdge'
      cursor: any
      node: {
        __typename?: 'Organization'
        id: string
        name: string
        description: string
        slug: string
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}
